import {dataService} from "services/data.service"
import Plot from "react-plotly.js"
import { useTranslation } from 'react-i18next'

export default function SideEffectGraph({mainDrug}) {
	const { t } = useTranslation()
	const drugs = dataService.getDrugs()
	const effects = dataService.getEffects()

	const x1 = []
	const y1 = []
	const text1 = []
	for (const drug of drugs) {
		if (drug !== mainDrug) {
			for (const effect of effects) {
				const datapoint = dataService.getDatapoint(drug, effect)
				y1.push(t(effect))
				x1.push(datapoint?.standard_rr)
				text1.push(t(drug))
			}
		}
	}

	const x2 = []
	const y2 = []
	const text2 = []

	const x3 = []
	const y3 = []
	const text3 = []

	for (const effect of effects) {
		const datapoint = dataService.getDatapoint(mainDrug, effect)
		if (effect === "EFFICACY") {
			y3.push(t(effect))
			x3.push(datapoint?.standard_rr)
			text3.push(t(mainDrug))
		} else {
			y2.push(t(effect))
			x2.push(datapoint?.standard_rr)
			text2.push(t(mainDrug))
		}
	}

	const data = [
		{
			mode: "markers",
			x: x1.reverse(),
			y: y1.reverse(),
			text: text1.reverse(),
			hoverinfo: "text",
			marker: {
				size: 10,
				color: "grey",
				symbol: 'diamond'
			},
			hoverlabel: {
				font: {
					color: 'white'
				}
			}
		},
		{
			mode: "markers",
			x: x2.reverse(),
			y: y2.reverse(),
			text: text2.reverse(),
			hoverinfo: "text",
			marker: {
				size: 15,
				color: "red",
				symbol: 'diamond'
			}
		},
		{
			mode: "markers",
			x: x3.reverse(),
			y: y3.reverse(),
			text: text3.reverse(),
			hoverinfo: "text",
			marker: {
				size: 15,
				color: "blue",
				symbol: 'diamond'
			}
		}
	]

	const config = {
		displayModeBar: false
	}

	const layout = {
		title: t("graph.drug.info.graph.title"),
		showlegend: false,
		xaxis: {
			title: t("graph.drug.info.graph.xaxis"),
			fixedrange: true,
			showticklabels: false,
		},
		yaxis: {
			fixedrange: true
		},
		margin: {
			l: 250,
			r: 50,
			b: 50,
			t: 50,
		},

		annotation: {
			x: 2,
			y: 0,
			xref: "x",
			showarrow: true
		}
	}

	return (
		<div className={`side-effect-info ${mainDrug}`}>
			<Plot
				data={data}
				layout={layout}
				config={config}
			/>
		</div>
	)

}
